export enum CompanyForm {
  ID = 'id',
  DISPLAY_NAME = 'displayName',
  LEGAL_NAME = 'legalName',
  WEBSITE = 'website',
  CONTACT_PERSON_ID = 'contactPersonId',
  IS_ACTIVE = 'isActive',

  ADDRESS = 'address',

  ADDRESS_TYPE = 'addressType',
  TITLE = 'title',
  STREET1 = 'street1',
  STREET2 = 'street2',
  CITY = 'city',
  STATE = 'state',
  ZIP = 'zip',
  WHOLE_OBJECT = 'wholeObject',
}
